export default {"src":"/_next/static/media/fx-private-relay-premium-logotype-light.77dce1c8.svg","height":22,"width":243,"blurWidth":0,"blurHeight":0};